"use client";

import { createContext, useContext, type ReactNode } from "react";

/**
 * Stands in for `usePathname` from `next/navigation`. The kit's navigation marks
 * the current item by comparing its `href` with the pathname. The apps here
 * keep the current section in the URL hash, so the app provides the current
 * location ("#overview") once, and every kit component reads it unchanged.
 */
const PathnameContext = createContext<string>("");

export const PathnameProvider = ({ pathname, children }: { pathname: string; children: ReactNode }) => (
    <PathnameContext.Provider value={pathname}>{children}</PathnameContext.Provider>
);

export const usePathname = (): string => useContext(PathnameContext);
